import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import on from 'dojo/on';
import { MainCatalogTypes, MainCatalogs_Classes } from "../_loadingHelpers/MainCatalogTypes";
import {
                                        // !! WICHTIG !!
    DutyTypeEditor,                     // Verwenden Sie MainCatalogEditorTools für alle Editor Importe,
    FunctionalGroupEditor,              // um Probleme mit zirkulärer Abhängigkeit zu vermeiden
    FunctionalMainGroupEditor,          // *************************************************************
    RoomEditor,
    EvTaskDescriptEditor,
    EvServiceEditor,
    TodoPackageEditor,
    PostalCodeEditor,
    OpusEditorV2,
    WebTranslationsEditor,
    ActivityStatusEditorV2,
    AddressCategoriesEditorV2,
    AddressMainCategoriesEditorV2,
    BookingStatusEditorV2,
    ProfessionsEditorV2,
    ServiceCategoriesEditorV2,
    ServicePackagesEditorV2,
    EvCategoriesEditorV2_1,
    EvCategoriesEditorV2_2,
    VenueEditorV2,
    FileCategoryEditorV2,
    DutyTypeEditorV2,
    EvTaskDescriptGroupEditorV2,
    EvTaskDescriptEditorV2,
    EvServiceEditorV2,
    FunctionalGroupEditorV2,
    RoomEditorV2,
    EvProjectTypeEditor,
    EvProcessStatusEditor,
    EvProcessGroupCategorieEditor,
    EvProcessGroupEditor,
    PhysicalResourcesEditor,
    ResourceMainGroupEditor,
    TodoCategoryEditor,
    TodoStatusEditor,
    TodoDescriptionEditor,
    ProfessionalTitlesEditor,
    AcademicTitlesPrefixEditor,
    AcademicTitlesSuffixEditor,
    JobTitleEditor,
    ComposerEditor,
    PerformersEditor,
    ExternalInstrumentsEditor,
    InternalInstrumentsEditor,
    RelationGroupsEditor,
    RelationTypesEditor,
    SellingStatusEditor,
    ExtendedPropertyEditor,
    ServiceChecklistCategoryEditor,
    ServicePackChecklistEditor,
    ServiceChecklistEditor,
    DistributionChannelEditor

} from './MainCatalogEditorTools';
import MainCatalogsEditorBase from '../MainCatalogsEditor/MainCatalogsEditorBase';
import StaticTable from '../../moreCore/UI/StaticTable/StaticTable';
import GenericDialog from '../../moreCore/UI/GenericDialog/GenericDialog';
import FinderBaseV2 from '../FinderBase/FinderBaseV2';
import MainCatalogsEditorBaseV2 from './MainCatalogsEditorBaseV2';
import DanielsMusicFinder from '../DanielsMusicFinder/DanielsMusicFinder';

class MainCatalogList extends compose(FinderBaseV2) {
    //templateString = template;

    //value: string = null;
    private heading: string = "";

    private useEditButton: boolean = false;


    catalogClass: MainCatalogs_Classes;
    //editForm: MainCatalogsEditorBase;

    //editFormMainHeader: HTMLElement;

    //headingContainer: HTMLElement;

    //catalogButtonShowEdit: HTMLButtonElement;
    //catalogButtonAddNew: HTMLButtonElement;

    //catalogEditErrorContainer: HTMLElement;
    //catalogEditErrorMessage: HTMLElement;

    //table: StaticTable = null;



    private tableFormatter(cell: StaticTable.StaticTableCell<any>) {

        switch (typeof (cell.value)) {
            case "boolean":
                // Standardformatter übernehmen lassen
                break;
            default:
                cell.contentnode.innerHTML = cell.value;
                break;
        }
        
        switch (cell.name) {

            case "ModificationDate":
                if (cell.value) {
                    let modDate = new Date(cell.value);
                    cell.contentnode.innerHTML = this.dojoDate.format(modDate, { datePattern: "dd.MM.yyyy", timePattern: "HH:mm:ss" });
                }
                return true;
                break;
            case "price_net":
                if (cell.entity.service_type === 1) {
                    if (cell.value) cell.contentnode.innerHTML = Number(cell.value).toFixed(2);
                    else cell.contentnode.innerHTML = "N.A.";
                } else {
                    cell.contentnode.innerHTML = "/";
                }
                return true;
                break;
            default:
                return false;
                break;
        }
    }

    private _onClick_TableRow(row: StaticTable.StaticTableRow<any>, rowGroup: StaticTable.StaticTableRowGroup<any>) {

        this.createNewEditor(rowGroup.entity, rowGroup.displayname, this.iconclass);
    }

    setHeading(label: string): void {

        this.heading = label;
        //this.headingContainer.innerHTML = this.label;

        //label ? this.UiModder.domClass.remove(this.headingContainer, "w3-hide") : this.UiModder.domClass.add(this.headingContainer, "w3-hide");
    }

    setEditButtonVisibility(visible: boolean = true) {
        this.useEditButton = visible === true;

        //this.UiModder.domClass.toggle(this.catalogButtonShowEdit, "w3-hide", this.useEditButton != true);
    }

    setCatalog(catalogClass: MainCatalogs_Classes, heading: string): void {

        this.catalogClass = catalogClass;

        this.setHeading(heading);

        let newEntryCallback = lang.hitch(this, this.createNewEditor);
        if (this.catalogClass == MainCatalogs_Classes.Opus && this.hasFeature("MainCatalog/DanielsAPI")) {

            newEntryCallback = lang.hitch(this, this.askForDanielsSearch);
        }

        let additionalRequestData: Array<{ name: string, value: any, setAsNewParameter?: boolean }> = [];
        additionalRequestData.push({ name: "entityClass", value: this.catalogClass });
        additionalRequestData.push({ name: "isFinderBase", value: true });

        this.setupFinder(
            "MainCatalogsEditor/LoadMainCatalogFinderConfig",
            "MainCatalogsEditor/LoadMainCatalogList",
            lang.hitch(this, this._onClick_TableRow),
            lang.hitch(this, this.tableFormatter),
            {
                neededUserRole: null,//this.catalogClass + "_Create",
                callback: newEntryCallback
            },
            additionalRequestData
        );

        this.removeNewButton();
    }

    private askForDanielsSearch() {
        //DanielsMusicFinder_Message_NewEntry

        let dlg = new GenericDialog();

        dlg.show(this.translate("DanielsMusicFinder_Message_NewEntry"),
            this.translate("DanielsMusicFinder_Header_WorksDaniels"),
            null,
            null,
            null,
            null,
            {
                size: "smaller",
                additionalButtons: [{
                    callback: null,
                    internalName: "cancel",
                    label: this.translate("GenericDialog__Btn_Cancel"),
                    bCloseOnClick: true
                }, {
                    callback: () => { this.createNewEditor() },
                    internalName: "manual",
                    label: this.translate("DanielsMusicFinder_Label_ManualWork"),
                    bCloseOnClick: true,
                    styleClass: "primary"
                },{
                    callback: () => { this.requestNewDanielsApiSearch() },
                    internalName: "daniels",
                    label: this.translate("DanielsMusicFinder_Label_DanielsSearch"),
                    bCloseOnClick: true,
                    styleClass: "primary"
                }]
            }
        )
    }

    private requestNewDanielsApiSearch() {
        if (!this.hasFeature("MainCatalog/DanielsAPI")) return;
        //this.requestContextButtonDisable("daniels");

        let daniels = new DanielsMusicFinder();
        daniels.showSearchWidget();
        on(daniels, "RequestNewEditorInstance", lang.hitch(this, this.createNewEditor))
    }

    private removeNewButton() {
        if (this.catalogClass === MainCatalogs_Classes.FunctionalGroup) {
            this.requestContextButtonRemove("new");
        }
    }

    private setupEventListeners(editform: MdsLax<InstanceType<typeof MainCatalogsEditorBase>> | MdsLax<InstanceType<typeof MainCatalogsEditorBaseV2>>): void {
        if (!editform) return;

        if (editform instanceof MainCatalogsEditorBase) {
            on(editform, "CatalogEntityData_Close", lang.hitch(this, this._onEvent_Close));
            on(editform, "CatalogEntityData_Save", lang.hitch(this, this._onEvent_Save));
            on(editform, "CatalogEntityData_Error", lang.hitch(this, this._onEvent_Error));
            on(editform, "CatalogEntityData_NoId", lang.hitch(this, this._onEvent_NoId));
        }

        else if (editform instanceof MainCatalogsEditorBaseV2) {
            on(editform, "closed", lang.hitch(this, this._onEvent_Close));
            on(editform, "CatalogEntityData_Save", lang.hitch(this, this._onEvent_Save));
            on(editform, "deleted", lang.hitch(this, this._onEvent_Save));
            on(editform, "error", lang.hitch(this, this._onEvent_Error));
            on(editform, "RequestNewEditorInstance", lang.hitch(this, this.createNewEditor))
        }
    }

    _onEvent_NoId(): void {

    }

    _onEvent_Save(id: string) {

        this.reload();
        //this.value = id;
        this.emitChangeEvent();
    }


    _onEvent_Close(): void {

    }

    _onEvent_Error(msg: string) {

        this.StandbyStop();
        this.reload();
        this._showErrorMessage(msg, true);
    }

    private createNewEditor(entity?: any, displayname?: string, iconclass?: string) {
        let entityId = null;

        if (entity) {
            try {
                entityId = entity.ID;
            } catch (ex) {
                alert("no ID-Property set for clicked entity!");
                return;
            }

        }

        if (!displayname) {
            displayname = this.translate("General_Loading");
        }

        let editForm: MdsLax<InstanceType<typeof MainCatalogsEditorBase>> = null;
        let editFormV2: MdsLax<InstanceType<typeof MainCatalogsEditorBaseV2>> = null;
        let newLabel: string = ""; // this.translate("General_CreateNew");

        switch (this.catalogClass) {
            case MainCatalogs_Classes.EvActivityStatus:
                newLabel = this.translate("General_Label_EvActivityStatus");
                editFormV2 = new ActivityStatusEditorV2();
                break;

            case MainCatalogs_Classes.EvBookingStatus:
                newLabel = this.translate("General_Label_EvBookingStatus");
                editFormV2 = new BookingStatusEditorV2();
                break;

            case MainCatalogs_Classes.OMDutyType:
                newLabel = this.translate("General_Label_OMDutyType");
                editFormV2 = new DutyTypeEditorV2();
                break;

            case MainCatalogs_Classes.FunctionalGroup:
                newLabel = this.translate("General_Label_FunctionalGroup");
                editFormV2 = new FunctionalGroupEditorV2();
                break;

            case MainCatalogs_Classes.FunctionalMainGroup:
                newLabel = this.translate("General_Label_FunctionalMainGroup");
                editForm = new FunctionalMainGroupEditor();
                break;

            case MainCatalogs_Classes.Venues:
                newLabel = this.translate("General_Label_Venue");
                editFormV2 = new VenueEditorV2();
                break;

            case MainCatalogs_Classes.EvRoom:
                newLabel = this.translate("General_Label_EvRoom");
                editFormV2 = new RoomEditorV2();
                break;

            case MainCatalogs_Classes.EvServices:
                newLabel = this.translate("General_Label_EvServices");
                editFormV2 = new EvServiceEditorV2();
                break;

            case MainCatalogs_Classes.ServiceCategory:
                newLabel = this.translate("General_Label_ServiceCategory");
                editFormV2 = new ServiceCategoriesEditorV2();
                break;

            case MainCatalogs_Classes.ServicePackage:
                newLabel = this.translate("General_Label_ServicePackage");
                editFormV2 = new ServicePackagesEditorV2();
                break;

            case MainCatalogs_Classes.ServiceChecklist:
                newLabel = this.translate("General_Label_ServiceChecklist");
                editFormV2 = new ServiceChecklistEditor();
                break;

            case MainCatalogs_Classes.ServiceChecklistCategory:
                newLabel = this.translate("General_Label_ServiceChecklistCategory");
                editFormV2 = new ServiceChecklistCategoryEditor();
                break;

            case MainCatalogs_Classes.ServicePackChecklist:
                newLabel = this.translate("General_Label_ServicePackChecklist");
                editFormV2 = new ServicePackChecklistEditor();
                break;

            case MainCatalogs_Classes.EvCategory_1:
                newLabel = this.translate("General_Label_EvCategory1");
                editFormV2 = new EvCategoriesEditorV2_1();
                break;

            case MainCatalogs_Classes.EvCategory_2:
                newLabel = this.translate("General_Label_EvCategory2");
                editFormV2 = new EvCategoriesEditorV2_2();
                break;

            case MainCatalogs_Classes.AddressMainCategory:
                newLabel = this.translate("General_Label_AddressMainCategory");
                editFormV2 = new AddressMainCategoriesEditorV2();
                break;

            case MainCatalogs_Classes.AddressCategory:
                newLabel = this.translate("General_Label_AddressCategory");
                editFormV2 = new AddressCategoriesEditorV2();
                break;

            case MainCatalogs_Classes.EvTaskDescript:
                newLabel = this.translate("General_Label_EvTaskDescript");
                editFormV2 = new EvTaskDescriptEditorV2();
                break;

            case MainCatalogs_Classes.EvTaskDescriptGroup:
                newLabel = this.translate("General_Label_EvTaskDescriptGroup");
                editFormV2 = new EvTaskDescriptGroupEditorV2();
                break;

            case MainCatalogs_Classes.FileCategory:
                newLabel = this.translate("General_Label_FileCategory");
                editFormV2 = new FileCategoryEditorV2();
                break;
            case MainCatalogs_Classes.TodoPackage:
                newLabel = this.translate("General_Label_TodoPackage");
                editFormV2 = new TodoPackageEditor();
                break;
            case MainCatalogs_Classes.Professions:
                newLabel = this.translate("General_Label_Professions");
                editFormV2 = new ProfessionsEditorV2();
                break;
            case MainCatalogs_Classes.Opus:
                newLabel = this.translate("General_Label_Opus");
                editFormV2 = new OpusEditorV2();
                break;
            case MainCatalogs_Classes.PostalCodes:
                newLabel = this.translate("General_Label_PostalCodes");
                editFormV2 = new PostalCodeEditor();
                break;
            case MainCatalogs_Classes.WebToolTranslations:
                newLabel = this.translate("General_Label_WebToolTranslations");
                editFormV2 = new WebTranslationsEditor();
                break;
            case MainCatalogs_Classes.EvProjectType2:
                newLabel = this.translate("General_Label_EvProjectType2");
                editFormV2 = new EvProjectTypeEditor();
                break;
            case MainCatalogs_Classes.EvProcessStatus:
                newLabel = this.translate("General_Label_EvProcessStatus");
                editFormV2 = new EvProcessStatusEditor();
                break;
            case MainCatalogs_Classes.EvProcessGroupCategorie:
                newLabel = this.translate("General_Label_EvProcessGroupCategorie");
                editFormV2 = new EvProcessGroupCategorieEditor();
                break;
            case MainCatalogs_Classes.EvProcessGroup:
                newLabel = this.translate("General_Label_EvProcessGroup");
                editFormV2 = new EvProcessGroupEditor();
                //editFormV2.setLabelAttribute("description")
                break;
            case MainCatalogs_Classes.PhysicalResources:
                newLabel = this.translate("General_Label_PhysicalResources");
                editFormV2 = new PhysicalResourcesEditor();
                break;
            case MainCatalogs_Classes.ResourceMainGroup:
                newLabel = this.translate("General_Label_ResourceMainGroup");
                editFormV2 = new ResourceMainGroupEditor();
                break;
            case MainCatalogs_Classes.TodoCategory:
                newLabel = this.translate("General_Label_TodoCategory");
                editFormV2 = new TodoCategoryEditor();
                break;
            case MainCatalogs_Classes.TodoStatus:
                newLabel = this.translate("General_Label_TodoStatus");
                editFormV2 = new TodoStatusEditor();
                break;
            case MainCatalogs_Classes.TodoDescription:
                newLabel = this.translate("General_Label_TodoDescription");
                editFormV2 = new TodoDescriptionEditor();
                break;
            case MainCatalogs_Classes.ProfessionalTitles:
                newLabel = this.translate("General_Label_ProfessionalTitles");
                editFormV2 = new ProfessionalTitlesEditor();
                break;
            case MainCatalogs_Classes.AcademicTitlesPrefix:
                newLabel = this.translate("General_Label_AcademicTitlesPrefix");
                editFormV2 = new AcademicTitlesPrefixEditor();
                break;
            case MainCatalogs_Classes.AcademicTitlesSuffix:
                newLabel = this.translate("General_Label_AcademicTitles");
                editFormV2 = new AcademicTitlesSuffixEditor();
                break;
            case MainCatalogs_Classes.JobTitle:
                newLabel = this.translate("General_Label_JobTitle");
                editFormV2 = new JobTitleEditor();
                break;
            case MainCatalogs_Classes.Performers:
                newLabel = this.translate("General_Label_Performers");
                editFormV2 = new PerformersEditor();
                break;
            case MainCatalogs_Classes.Composers:
                newLabel = this.translate("General_Label_Composers");
                editFormV2 = new ComposerEditor();
                break;
            case MainCatalogs_Classes.ExternalInstrument:
                newLabel = this.translate("General_Label_ExternalInstruments");
                editFormV2 = new ExternalInstrumentsEditor();
                break;
            case MainCatalogs_Classes.InternalInstrument:
                newLabel = this.translate("General_Label_InternalInstruments");
                editFormV2 = new InternalInstrumentsEditor();
                break;
            case MainCatalogs_Classes.RelationGroups:
                newLabel = this.translate("General_Label_RelationGroups");
                editFormV2 = new RelationGroupsEditor();
                break;
            case MainCatalogs_Classes.RelationTypes:
                newLabel = this.translate("General_Label_RelationTypes");
                editFormV2 = new RelationTypesEditor();
                break;
            case MainCatalogs_Classes.SellingStatus:
                newLabel = this.translate("General_Label_SellingStatus");
                editFormV2 = new SellingStatusEditor();
                break;
            case MainCatalogs_Classes.ExtendedProperty:
                newLabel = this.translate("General_Label_ExtendedProperty");
                editFormV2 = new ExtendedPropertyEditor();
                break;
            case MainCatalogs_Classes.DistributionChannel:
                newLabel = this.translate("General_Label_DistributionChannel");
                editFormV2 = new DistributionChannelEditor();
                break;
            default:
                console.warn("Main catalogs: unknown catalog class " + this.catalogClass);
                alert(this.id + ": unknown catalog class " + this.catalogClass);
                return;
                break;

        }
        if (newLabel) {
            newLabel = this.translate("General_CreateNew") + " - " + newLabel;
        } else {
            newLabel = this.translate("General_CreateNew");
        }

        if (editForm) {
            editForm.setHeading(newLabel);

            if (this.isEmbeddedInTab) {
                this.requestNewTabbedContent({
                    enableClosing: true,
                    label: entityId ? displayname : newLabel,
                    sidebarEntryName: entityId ? entityId : "new-" + this.catalogClass,
                    name: entityId ? entityId : "_blank",
                    widget: editForm,
                    coloration: this.tabColor,
                    groupLabel: this.heading
                }, true);
            } else {
                // in dlg anzeigen...
            }
            editForm.getEditFormInfo(entityId);
            this.setupEventListeners(editForm);
        }

        else if (editFormV2) {

            if (this.isEmbeddedInTab) {
                this.requestNewTabbedContent({
                    enableClosing: true,
                    iconclass: this.iconclass,
                    label: entityId ? displayname : newLabel,
                    sidebarEntryName: entityId ? entityId : "new-" + this.catalogClass,
                    name: entityId ? entityId : "new-" + this.catalogClass,
                    widget: editFormV2,
                    coloration: this.tabColor,
                    groupLabel: this.heading
                }, true);
            } else {
                //Show dlg
                var dlg = new GenericDialog();

            }

            if (entityId) {
                editFormV2.loadEntity(entityId);
            } else {
                editFormV2.updateHeading(newLabel);
                editFormV2.setStartupState("ready");
            }

            this.setupEventListeners(editFormV2);
        }
    }

    _showErrorMessage(message: string, isError: boolean = true) {
        if (!message) {

        } else {
            let dlg = new GenericDialog;
            dlg._setHeaderAttr("");
            dlg._setContentAttr(message);
            dlg._setOkBtnAttr(true);
            dlg._setCloseBtnAttr(false);
            dlg._setTopCloseBtnAttr(true);

            if (isError) {
                dlg._setTextIconAttr("fas fa-times-circle warning");
            } else {

            }

            dlg.show();
        }
    }

    emitChangeEvent(entity?: any): void {

        this.emit("change", entity);
    }

    _onEmbedding() {
        super._onEmbedding.apply(this, arguments as any);

        //this.createDefaultButton("new", lang.hitch(this, this.createNewEditor)); // wird über setupFinder geregelt!


    }

    _onTableCreated(table: MdsLax<InstanceType<typeof StaticTable>>) {
    //    table.showIndexColumn = true;
    //    table.indexOffset = this._getOffsetFromPage(this._currentPage);
    }


    //BASE
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.RequestManager.handleAs = "json";

        this.disableConfigStorage = true;

        //on(this.catalogSearchSelect, "loaded", lang.hitch(this, this.busyEnd));

    }
    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(MainCatalogList);
